import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-xxl-8 order-2 order-xl-1" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-10" }
const _hoisted_5 = { class: "settings-tabs ps-0 mb-0 list-unstyled" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_21 = { class: "language-switcher-wrapper mt-20 mt-md-25 pt-15 pt-md-20 border-top" }
const _hoisted_22 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_23 = { class: "text-black fw-semibold fs-14" }
const _hoisted_24 = { class: "language-switcher" }
const _hoisted_25 = {
  key: 1,
  class: "text-center py-5"
}

import { ref, onMounted, reactive, inject, computed } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { User } from "@/utils/Model";
import BlotFormatter from "quill-blot-formatter";
import ImageUploader from "quill-image-uploader";
import axios from "axios";
import router from '../../../router/index'
import { checkSessionValidate } from "@/utils/function";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountSettings',
  setup(__props) {

const backApi = inject('back');
const { locale, t } = useI18n();

// Récupérer la langue actuelle
const currentLocale = computed(() => locale.value);
console.log('LA LANGUE ACTUELLE EST =====', currentLocale.value);

const changeLanguage = (lang: string) => {
  console.log('LA LANGUE CHOISIE EST =====', lang);
  locale.value = lang;
  localStorage.setItem("lang", lang);
};

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

let organizationName: string | null = localStorage.getItem('organization_name');
let userName: string | null = localStorage.getItem('name');
let email: string | null = localStorage.getItem('email');

const user = ref({} as User);
const pageLoad = ref(false);
const isLoading = ref(true); // Ajout d'un état de chargement

const showUserInfo = () => {
  axios.get(backApi + '/secure/users/' + codeUser + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      user.value = response.data;
      console.log(response.data);
      // Ne pas modifier pageLoad ici
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          console.log(error.response);
        }
      }
    }).finally(() => {
      // Une fois les données chargées, afficher la page
      pageLoad.value = true;
      isLoading.value = false;
    });
}

onMounted(() => {
  checkSessionValidate(1);
  
  // Récupérer la langue depuis localStorage
  const savedLang = localStorage.getItem('lang');
  if (savedLang) {
    locale.value = savedLang;
  }
  
  // Appeler la fonction pour charger les données
  showUserInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (pageLoad.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/account-settings",
                    class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.personalInfo')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/settings-change-password",
                    class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.changePassword')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/settings-organization",
                    class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition settings-tab-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('settings.editOrganization')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('settings.organizationName')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(organizationName) ? (organizationName).value = $event : organizationName = $event)),
                        readonly: "",
                        type: "text",
                        class: "form-control shadow-none rounded-0 text-black"
                      }, null, 512), [
                        [_vModelText, _unref(organizationName)]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('settings.firstName')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(userName) ? (userName).value = $event : userName = $event)),
                        readonly: "",
                        type: "text",
                        class: "form-control shadow-none rounded-0 text-black"
                      }, null, 512), [
                        [_vModelText, _unref(userName)]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('settings.lastName')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(userName) ? (userName).value = $event : userName = $event)),
                        readonly: "",
                        type: "text",
                        class: "form-control shadow-none rounded-0 text-black"
                      }, null, 512), [
                        [_vModelText, _unref(userName)]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('settings.email')), 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                        readonly: "",
                        type: "email",
                        class: "form-control shadow-none rounded-0 text-black",
                        placeholder: "e.g. adam127704@gmail.com"
                      }, null, 512), [
                        [_vModelText, _unref(email)]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('settings.language')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm rounded-0 transition", { active: currentLocale.value === 'fr' }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (changeLanguage('fr')))
                    }, " FR ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm rounded-0 transition", { active: currentLocale.value === 'en' }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (changeLanguage('en')))
                    }, " EN ", 2)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("div", {
          class: "spinner-border text-primary",
          role: "status"
        }, [
          _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
        ], -1)
      ]))]))
}
}

})